import { AssetsApi } from './assets';
import { CalendarParamsReq, CalendarResponse } from './api-types/calendar';

export class CalendarApi extends AssetsApi {
  calendarActivities(params: CalendarParamsReq) {
    return this.requestGet<CalendarResponse>('activities/calendar', {
      ...params,
      'page.Num': 1,
      'page.Size': 1000,
    });
  }
}
